export const pad2 = (n: number): string => String(n).padStart(2, '0');
export const toLocalYmdFromDate = (d: Date): string =>
	`${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const normalizeToYmd = (s: string): string =>
	s.includes('T') ? toLocalYmdFromDate(new Date(s)) : s.slice(0, 10);
